module.exports = __webpack_public_path__ + "img/recharge_bg_allow.12a0591c.png";